import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Alert,
  Stack
} from '@mui/material';
import {
  Block as BlockIcon,
  ContactSupport as ContactIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * 账号被禁用页面组件
 * 当用户账号被管理员禁用时显示的友好提示页面
 */
const AccountDisabledPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/landing');
  };

  const handleContactSupport = () => {
    // 这里可以跳转到客服页面或显示联系方式
    window.open('mailto:support@pagesmooth.com', '_blank');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Card
          sx={{
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            borderRadius: 3
          }}
        >
          <CardContent sx={{ p: 4 }}>
            {/* 图标 */}
            <Box sx={{ mb: 3 }}>
              <BlockIcon
                sx={{
                  fontSize: 80,
                  color: '#f44336',
                  mb: 2
                }}
              />
            </Box>

            {/* 标题 */}
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: '#333',
                mb: 2
              }}
            >
              账号已被禁用
            </Typography>

            {/* 说明文字 */}
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 3, lineHeight: 1.6 }}
            >
              很抱歉，您的账号已被管理员暂时禁用。
              <br />
              如有疑问，请联系客服获取帮助。
            </Typography>

            {/* 警告提示 */}
            <Alert
              severity="warning"
              sx={{
                mb: 4,
                textAlign: 'left',
                '& .MuiAlert-message': {
                  width: '100%'
                }
              }}
            >
              <Typography variant="body2">
                <strong>可能的原因：</strong>
                <br />
                • 违反了平台使用条款
                <br />
                • 账号存在异常活动
                <br />
                • 需要进一步的身份验证
              </Typography>
            </Alert>

            {/* 操作按钮 */}
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
            >
              <Button
                variant="contained"
                startIcon={<ContactIcon />}
                onClick={handleContactSupport}
                sx={{
                  backgroundColor: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1565c0'
                  }
                }}
              >
                联系客服
              </Button>
              
              <Button
                variant="outlined"
                startIcon={<HomeIcon />}
                onClick={handleGoHome}
              >
                返回首页
              </Button>
            </Stack>

            {/* 联系信息 */}
            <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
              <Typography variant="body2" color="text.secondary">
                客服邮箱: support@pagesmooth.com
                <br />
                工作时间: 周一至周五 9:00-18:00
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default AccountDisabledPage; 